export var backgrounds = {
  "default": "background",
  light: "backgroundLight",
  lightTint: "backgroundLightTint",
  darkLight: "backgroundDarkLight",
  dark: "backgroundDark",
  darker: "backgroundDarker",
  black: "backgroundBlack",
  defaultToLight: "backgroundDefaultToLight",
  lightToDefault: "backgroundLightToDefault",
  darkToDarker: "backgroundDarkToDarker",
  darkerToDark: "backgroundDarkerToDark"
};
export var spacingSpace = {
  giant: {
    small: 16,
    // 96px
    medium: 16,
    // 96px
    large: 30 // 240px
  },
  huge: {
    small: 8,
    // 64px
    medium: 12,
    // 96px
    large: 30 // 240px
  },
  large: {
    small: 8,
    // 64px
    medium: 12,
    // 96px
    large: 25 // 200px
  },
  big: {
    small: 8,
    // 64px
    medium: 12,
    // 96px
    large: 15 // 120px
  },
  "default": {
    small: 6,
    // 48px
    medium: 8,
    // 64px
    large: 10 // 80px
  },
  small: {
    small: 3,
    // 24px
    medium: 4,
    // 32px
    large: 5 // 40px
  },
  extraSmall: {
    small: 3,
    // 24px
    medium: 3,
    // 24px
    large: 3 // 24px
  },
  sticky: 0
};